
import React from 'react';
import { useLanguage } from '@/contexts/language';
import { Button } from "@/components/ui/button";

interface RegionNavigationProps {
  onRegionSelect: (regionId: string) => void;
  isChiapasActive?: boolean;
  isHidalgoActive?: boolean;
}

const RegionNavigation: React.FC<RegionNavigationProps> = ({
  onRegionSelect,
  isChiapasActive,
  isHidalgoActive
}) => {
  const { t } = useLanguage();
  
  return (
    <div className="flex space-x-2">
      <Button
        variant="ghost"
        onClick={() => onRegionSelect('CHIS')}
        className={`${isChiapasActive ? 'bg-white/20' : ''} text-white hover:bg-white/20 px-3 py-2`}
      >
        Chiapas
      </Button>
      <Button
        variant="ghost"
        onClick={() => onRegionSelect('HGO')}
        className={`${isHidalgoActive ? 'bg-white/20' : ''} text-white hover:bg-white/20 px-3 py-2`}
      >
        Hidalgo
      </Button>
    </div>
  );
};

export default RegionNavigation;
